import { useState, useEffect } from 'react';
import appConfig from '../config';

interface AppConfig {
  debug: boolean;
  app_name: string;
  sample_questions?: string[];
  ui_theme?: {
    app_background: string;
    sample_question_background: string;
    sample_question_text: string;
    sample_question_border: string;
    sample_question_hover_background: string;
    sample_question_hover_text: string;
    sample_question_hover_border: string;    recording_button_background: string;
    recording_button_hover_background: string;
    recording_button_recording_background: string;
    recording_button_recording_hover_background: string;    text_input_background: string;
    text_input_text: string;
    text_input_border: string;    text_input_border_focus: string;    send_button_background: string;
    send_button_hover_background: string;    new_conversation_button_background: string;
    new_conversation_button_hover_background: string;
    user_message_background: string;
    user_message_text: string;
    user_message_border: string;
    user_icon_background: string;
    user_icon_color: string;    assistant_icon_background: string;
    assistant_icon_color: string;
    assistant_message_background: string;
    assistant_message_text: string;    assistant_message_border: string;
    user_message_type_background: string;
    assistant_message_type_background: string;
    sources_button_text: string;
    sources_button_icon: string;
    sources_button_background: string;
    sources_button_border: string;
    sources_button_count_text: string;
    sources_button_count_background: string;
  };
}

const FALLBACK_CONFIG: AppConfig = {
  debug: false,
  app_name: 'Loading...',
};

export const useConfig = () => {
  const [config, setConfig] = useState<AppConfig | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await fetch(`${appConfig.apiUrl}/config`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch config: ${response.statusText}`);
        }
        
        const configData = await response.json();
        setConfig(configData);
        setError(null);
      } catch (err) {
        console.error('Failed to fetch config from backend:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
        setConfig(FALLBACK_CONFIG);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { config, loading, error };
};
